import React from 'react';

export default function Coin({ type, coin, size = 200 }) {
  const s   = size;
  const r   = s / 2;
  const rim = s * 0.055;

  const G = {
    face1: '#F7D060',
    face2: '#C9920A',
    face3: '#8B6200',
    rim1:  '#FFE87A',
    rim2:  '#B8860B',
    text:  '#000000',   // pure black — bold and clear
  };

  return (
    <svg width={s} height={s} viewBox={`0 0 ${s} ${s}`} style={{ flexShrink: 0, overflow: 'visible' }}>
      <defs>
        <radialGradient id={`face-${type}`} cx="38%" cy="28%" r="72%">
          <stop offset="0%"   stopColor={G.face1} />
          <stop offset="45%"  stopColor={G.face2} />
          <stop offset="100%" stopColor={G.face3} />
        </radialGradient>
        <linearGradient id={`rim-${type}`} x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%"   stopColor={G.rim1} />
          <stop offset="50%"  stopColor={G.rim2} />
          <stop offset="100%" stopColor={G.rim1} />
        </linearGradient>
        <radialGradient id={`gloss-${type}`} cx="38%" cy="22%" r="55%">
          <stop offset="0%"   stopColor="white" stopOpacity="0.22" />
          <stop offset="100%" stopColor="white" stopOpacity="0" />
        </radialGradient>
      </defs>

      {/* Simple thin clean colored circle — type identity ring */}
      <circle
        cx={r} cy={r} r={r - 1}
        fill="none"
        stroke={coin.color}
        strokeWidth={Math.max(1.5, s * 0.022)}
        opacity="1"
      />

      {/* Gold rim */}
      <circle cx={r} cy={r} r={r - s * 0.04} fill={`url(#rim-${type})`} />

      {/* Rim knurling dots */}
      {Array.from({ length: 30 }).map((_, i) => {
        const a = (i * (360 / 30) * Math.PI) / 180;
        const d = r - rim - s * 0.02;
        return <circle key={i} cx={d * Math.cos(a) + r} cy={d * Math.sin(a) + r} r={s * 0.01} fill={G.rim2} opacity="0.5" />;
      })}

      {/* Gold face */}
      <circle cx={r} cy={r} r={r - rim - s * 0.032} fill={`url(#face-${type})`} />

      {/* Inner engraved ring */}
      <circle cx={r} cy={r} r={r - rim - s * 0.088} fill="none" stroke={G.face3} strokeWidth={s * 0.005} opacity="0.3" />

      {/* Faint background symbol */}
      <text x={r} y={r + s * 0.1} textAnchor="middle" fontSize={s * 0.2} fill="#000" opacity="0.08" fontFamily="Georgia, serif">{coin.symbol}</text>

      {/* Type code — bold black */}
      <text
        x={r} y={r - s * 0.04}
        textAnchor="middle"
        fontSize={s * 0.16}
        fontWeight="900"
        fill={G.text}
        opacity="0.88"
        fontFamily="'Cinzel', Georgia, serif"
        letterSpacing={s * 0.012}
      >{type}</text>

      {/* Motto — top arc, black */}
      <path id={`atop-${type}`} d={`M ${r-(r-rim-s*0.055)} ${r} A ${r-rim-s*0.055} ${r-rim-s*0.055} 0 0 1 ${r+(r-rim-s*0.055)} ${r}`} fill="none" />
      <text fontSize={s * 0.048} fill="#000" opacity="0.55" fontFamily="'Cinzel', serif" letterSpacing={s * 0.004}>
        <textPath href={`#atop-${type}`} startOffset="50%" textAnchor="middle">{coin.motto}</textPath>
      </text>

      {/* Metal label — bottom arc, bold black */}
      <path id={`abot-${type}`} d={`M ${r-(r-rim-s*0.055)} ${r} A ${r-rim-s*0.055} ${r-rim-s*0.055} 0 0 0 ${r+(r-rim-s*0.055)} ${r}`} fill="none" />
      <text fontSize={s * 0.062} fontWeight="700" fill="#000" opacity="0.75" fontFamily="'Cinzel', serif" letterSpacing={s * 0.003}>
        <textPath href={`#abot-${type}`} startOffset="50%" textAnchor="middle">{coin.metal.toUpperCase()}</textPath>
      </text>

      {/* Year */}
      <text x={r} y={r + s * 0.43} textAnchor="middle" fontSize={s * 0.048} fontWeight="600" fill="#000" opacity="0.35" fontFamily="'Cinzel', serif">{coin.year}</text>

      {/* Gloss */}
      <circle cx={r} cy={r} r={r - rim - s * 0.032} fill={`url(#gloss-${type})`} />
    </svg>
  );
}
